import { observable, makeObservable, action } from 'mobx';

import { handleSceneDetail, handleCaseAllData, handleSceneProgress, handleRestart, handleCaseDetail } from '@/api/grt/simulation';
import { cloneDeep } from 'lodash';
import { Storage } from '@/utils/Storage';
import { caseCodeMap } from '@/utils/contants/caseSimulation';
import { goSideLogin } from '@/httpService/baseConfig';
import grtAi from './index.js';
import chatStore from './chat.js';
class SimulationStore {
    constructor() {
        makeObservable(this);
    }
    @observable simulationParams = {
        agentId: '',
        caseId: '',
        sceneId: '',
        side: ''
    };
    @action setSimulationParams = (params) => {
        this.simulationParams = {
            ...this.simulationParams,
            ...params
        };
    };
    getPath = () => {
        const { agentId, caseId, sceneId, side } = this.simulationParams;
        return `/${side}/o/${agentId}/simulation/${caseId}/${sceneId}`;
    };
    @observable errorCode = '';
    @action setErrorCode = (code) => {
        this.errorCode = code;
    };
    @observable pageProgress = null;
    @action setPageProgress = (progress) => {
        this.pageProgress = progress;
    };
    @observable caseId = '';
    @action setCaseId = (id) => {
        this.caseId = id;
    };
    @observable showCaseCard = false;
    @action setShowCaseCard = (flag) => {
        this.showCaseCard = flag;
    };
    @observable headerIcon = {
        role: false,
        back: false,
        reStart: false
    };
    @action setHeaderIcon = (data) => {
        this.headerIcon = {
            ...this.headerIcon,
            ...data
        };
    };
    @observable caseInfo = {};
    @action setCaseInfo = (data) => {
        this.caseInfo = data;
    };
    @observable sceneDetail = {};
    @action setSceneDetail = (data) => {
        this.sceneDetail = data;
    };
    //所有的数据
    @observable allContentData = {};
    @action setAllContentData = (data) => {
        this.allContentData = data;
    };
    //背景数据-------------------------------
    @observable background = {
        content: '',
        sections: []
    };
    @action setBackground = (data) => {
        this.background = data;
    };

    //人物角色-------------------------------
    @observable character = {};
    @action setCharacter = (data) => {
        this.character = data;
    };
    //目标
    @observable goal = {};
    @action setGoal = (data) => {
        this.goal = data;
    };
    //规则
    @observable rules = [];
    @action setRules = (data) => {
        this.rules = data;
    };
    //背景详情----------------------------------------
    @observable sections = [];
    @action setSections = (data) => {
        this.sections = data;
    };
    @observable curSectionIndex = 0;
    @action setCurSectionIndex = (index) => {
        this.curSectionIndex = index;
    };
    @observable curSection = {};
    @action setCurSection = (data) => {
        this.curSection = data;
    };
    @observable preSectionIndex = 0;
    @action setPreSectionIndex = (index) => {
        this.preSectionIndex = index;
    };
    @observable preSection = {};
    @action setPreSection = (data) => {
        this.preSection = data;
    };
    @observable currentViewIndex = 0;
    @action setCurrentViewIndex = (index) => {
        this.currentViewIndex = index;
    };
    @observable isFading = false;
    @action setIsFading = (flag) => {
        this.isFading = flag;
    };
    //处理每张卡片是否解锁
    handleChangeCurSection = (section) => {
        this.setIsFading(true);
        let sectionCopy = cloneDeep(this.sections);
        const index = sectionCopy.findIndex((item) => item.section_id === section.section_id);
        sectionCopy.forEach((item, idx) => {
            //未解锁
            if (item.locked && (index === idx || idx === index + 1)) {
                item.locked = false;
            }
        });
        this.setCurSection(section);
        this.setSections(sectionCopy);
        this.setIsFading(false);
        // setTimeout(() => {
        //     this.setIsFading(false);
        // }, 300); // 与CSS动画时长一致
    };
    //获取场景详情
    getSceneDetail = async (id) => {
        let res = await handleSceneDetail(id);
        if (res.success) {
            this.setSceneDetail(res.data);
        } else {
            this.setSceneDetail({});
        }
    };
    //处理错误---仅针对案例仿真，所以只做一个接口的错误处理
    handleError = (rescode) => {
        let code = String(rescode);
        this.setErrorCode(code);
        if (code === '3013') {
            return caseCodeMap.noAuth;
        }
        if (code === '3012') {
            goSideLogin(chatStore?.side);
            return caseCodeMap.noLogin;
        }
        return;
    };
    //获取案例详情
    getCaseInfo = async (runtime_session_id) => {
        let res = await handleCaseDetail(runtime_session_id);
        if (res.success) {
            this.setCaseInfo(res.data);
            return true;
        } else {
            this.handleError(res?.code);
            this.setCaseInfo({});
            return false;
        }
    };

    //引导弹窗------------------------------------------------
    @observable guideModalName = null; //back role
    @action setGuideModal = (name) => {
        this.guideModalName = name;
    };
    @observable guideModalShow = {
        back: false,
        role: false,
        restart: false
    };
    @action setGuideModalShow = (data) => {
        this.setGuideModal(null);
        this.guideModalShow = {
            ...this.guideModalShow,
            ...data
        };
    };
    backStorageName = 'backGuide';
    roleStorageName = 'roleGuide';
    factorStorageName = 'factorGuide';
    handleBackStorage = (flag) => {
        Storage.set(this.backStorageName, flag);
    };
    handleRoleStorage = (flag) => {
        Storage.set(this.roleStorageName, flag);
    };

    // 事件答题----------------------------------------------------------
    @observable loading = false;
    @action setLoading = (flag) => {
        this.loading = flag;
    };
    //答案是否为空
    @observable isEmptyAnswer = false;
    @action
    setIsEmptyAnswer = (flag) => {
        this.isEmptyAnswer = flag;
    };
    @observable curUserAnswer = {
        user_answer: [],
        custom_value: ''
    };
    @action setCurUserAnswer = (data) => {
        this.curUserAnswer = {
            ...this.curUserAnswer,
            ...data
        };
    };
    resetCurUserAnswer = () => {
        this.setCurUserAnswer({
            user_answer: [],
            custom_value: ''
        });
    };
    @observable events = [];
    @action setEvents = (data) => {
        this.events = data;
    };
    @observable pageShowEvent = [];
    @action setPageShowEvent = (data) => {
        this.pageShowEvent = data;
    };
    @observable curEventData = {};
    @action setCurEventData = (data) => {
        this.curEventData = data;
    };
    @observable curEventIndex = 0;
    @action setCurEventIndex = (index) => {
        this.curEventIndex = index;
    };
    @observable curQuestionIndex = 0;
    @action setCurQuestionIndex = (index) => {
        this.curQuestionIndex = index;
    };
    @observable curQuestion = {};
    @action setCurQuestion = (data) => {
        this.curQuestion = data;
    };
    //根据当前场景索引，更新页面上显示的场景列表
    updatePageShowEvent = () => {
        let { curEventIndex, events } = this;
        let startIndex = curEventIndex - 3 < 0 ? 0 : curEventIndex - 3;
        let temData = events.slice(startIndex, curEventIndex + 1);
        this.setPageShowEvent(temData);
    };
    //切换问题
    changeCurQuestionIndex = (index) => {
        this.resetCurUserAnswer();
        this.setCurQuestionIndex(index);
        this.setCurQuestion(this.curEventData.questions[index]);
    };
    //切换事件
    changeCurEventIndex = (index) => {
        this.resetCurUserAnswer();
        this.setCurEventIndex(index);
        this.setCurEventData(this.events[index]);
        this.changeCurQuestionIndex(0);
    };

    //   事件结果-------------------------------------------------
    @observable eventResult = {};
    @action setEventResult = (data) => {
        this.eventResult = data;
    };
    // 评阅报告--------------------------------------------
    @observable reviewReport = {};
    @action setReviewReport = (data) => {
        this.reviewReport = data;
    };
    @observable reportCards = [];
    @action setReportCards = (data) => {
        this.reportCards = data;
    };
    //获取事件的用户选择
    getEventChoice = (userChoices, scenario_id) => {
        let event = userChoices.find((item) => item.scenario_id === scenario_id);
        return event;
    };

    //整合报告卡片的信息
    getReportCards = async (events, userChoices) => {
        if (!userChoices) {
            return;
        }
        let data = events;
        data.forEach((item, index) => {
            let eventChoice = this.getEventChoice(userChoices, item.scenario_id);
            item.choice_path = eventChoice?.choice_path || '';
            item.impact_analysis = eventChoice?.impact_analysis || '';
            if (index === 0) {
                item.expand = true;
            } else {
                item.expand = false;
            }
        });
        this.setReportCards(data);
    };
    getApiProgress = async (caseId) => {
        let res = await handleSceneProgress(caseId);
        if (res && res.success) {
            this.setPageProgress(res.data?.stage);
            return res.data?.stage;
        }
        this.setPageProgress(null);
        return false;
    };
    verifyLogin = async () => {
        let res = await grtAi.checkLogin();
        if (!res) {
            goSideLogin('web');
        }
        return res;
    };
    //关闭弹窗
    closeGuideModal = () => {
        this.setGuideModalShow({
            role: false,
            back: false,
            restart: false
        });
    };
    //重新开始
    reStart = async (caseId, callback) => {
        let isLogin = await this.verifyLogin();
        if (!isLogin) {
            return false;
        }
        let res = await handleRestart(caseId);
        if (res && res.success) {
            // this.getContent();
            // this.closeGuideModal();
            callback?.();
            return true;
        }
        return false;
    };
    getContent = async (runtime_session_id) => {
        let allData = {};
        let res = await handleCaseAllData(runtime_session_id || this.caseId);
        if (res && res.success) {
            allData = res.data;
        }

        let { event_result = {}, review_report = {} } = allData;
        let data = allData.content || {};
        this.setAllContentData(allData);
        let { background = {}, character = {}, goal = {}, rules = [], scenarios = [] } = data;
        scenarios.forEach((item, index) => {
            item.originalIndex = index;
        });
        let sections = background.sections || [];
        sections.forEach((item, index) => {
            item.originalIndex = index;
            if (index === 0 || index === 1) {
                item.locked = false;
            } else {
                item.locked = true;
            }
        });
        this.setBackground(background);
        this.setCharacter(character);
        this.setGoal(goal);
        this.setRules(rules);
        this.setSections(sections);
        this.setCurSection(sections[0]);
        this.setEvents(scenarios);
        this.setCurEventData(scenarios[0]);
        this.setCurQuestion(scenarios[0]?.questions[0]);
        this.setEventResult(event_result);
        this.setReviewReport(review_report);
        this.getReportCards(scenarios, review_report?.user_performance);
    };
}

export default new SimulationStore();
